<template>
  <v-app id="sign">
    <v-main class="auth-main">
      <div class="auth-wrapper">
        <v-card class="auth-card" elevation="12" rounded="xl">
          <v-row no-gutters>
            <!-- Painel de marca (desktop) -->
            <v-col
              cols="12"
              md="5"
              class="auth-brand d-none d-md-flex flex-column align-center justify-center pa-8"
            >
              <img
                :src="require('@/assets/outpacking-logo.svg')"
                alt="Outpacking Logo"
                class="auth-brand__logo mb-6"
              />
              <h1 class="auth-brand__title">Outpacking</h1>
              <p class="auth-brand__subtitle">Módulo de Compras</p>
            </v-col>

            <!-- Painel do formulário -->
            <v-col cols="12" md="7" class="auth-form pa-6 pa-sm-10">
              <div class="auth-form__inner">
                <!-- Logo compacto (mobile) -->
                <div class="d-flex d-md-none justify-center mb-6">
                  <img
                    :src="require('@/assets/outpacking-logo.svg')"
                    alt="Outpacking Logo"
                    class="auth-form__logo"
                  />
                </div>

                <h2 class="auth-form__heading">
                  {{ tab === 0 ? 'Bem-vindo de volta' : 'Criar conta' }}
                </h2>
                <p class="auth-form__hint">
                  {{
                    tab === 0
                      ? 'Entre com suas credenciais para continuar.'
                      : 'Preencha os dados abaixo para se cadastrar.'
                  }}
                </p>

                <v-tabs
                  v-model="tab"
                  grow
                  color="#CF122E"
                  class="auth-tabs mb-6"
                >
                  <v-tab :value="0" class="text-none">Login</v-tab>
                  <v-tab :value="1" class="text-none">Cadastro</v-tab>
                </v-tabs>

                <v-tabs-window v-model="tab">
                  <v-tabs-window-item :value="0">
                    <LogIn
                      @login-success="displayLoginSuccessToast"
                      @login-fail="displayLoginFailToast"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item :value="1">
                    <SignUp
                      @signup-success="displaySignupSuccessToast"
                      @signup-fail="displaySignupFailToast"
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-main>

    <v-snackbar :color="snackbarColor" v-model="snackbar" :timeout="4000" location="top">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn variant="text" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import LogIn from '@/components/Sign/LogIn.vue';
import SignUp from '@/components/Sign/SignUp.vue';

export default {
  name: 'SignPage',

  components: { LogIn, SignUp },

  data: () => ({
    snackbar: false,
    snackbarText: 'Erro login in.',
    snackbarColor: 'red',
    tab: 0,
  }),

  methods: {
    displayLoginSuccessToast() {
      this.snackbarText = 'Login feito com sucesso.';
      this.snackbarColor = 'green';
      this.snackbar = true;
    },

    displayLoginFailToast() {
      this.snackbarText = 'Falha ao fazer login.';
      this.snackbarColor = 'red';
      this.snackbar = true;
    },

    displaySignupSuccessToast() {
      this.snackbarText = 'Cadastro feito com sucesso.';
      this.snackbarColor = 'green';
      this.snackbar = true;
    },

    displaySignupFailToast() {
      this.snackbarText = 'Falha ao realizar cadastro.';
      this.snackbarColor = 'red';
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.auth-main {
  background:
    radial-gradient(1200px 600px at 15% 10%, rgba(207, 18, 46, 0.18), transparent 55%),
    radial-gradient(900px 500px at 90% 90%, rgba(74, 78, 84, 0.35), transparent 50%),
    linear-gradient(160deg, #1b1d21 0%, #101114 100%);
}

/* Garante centralização E rolagem em telas baixas (o botão nunca some) */
.auth-wrapper {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.auth-card {
  width: 100%;
  max-width: 940px;
  overflow: hidden;
}

/* --- Painel de marca --- */
.auth-brand {
  background: linear-gradient(155deg, #cf122e 0%, #9d0f24 100%);
  color: #fff;
  text-align: center;
}

.auth-brand__logo {
  width: 60%;
  max-width: 200px;
  filter: brightness(0) invert(1);
}

.auth-brand__title {
  font-size: 1.9rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.1;
}

.auth-brand__subtitle {
  margin-top: 6px;
  font-size: 1rem;
  opacity: 0.85;
}

/* --- Painel do formulário --- */
.auth-form {
  display: flex;
  align-items: center;
}

.auth-form__inner {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

.auth-form__logo {
  width: 140px;
  max-width: 60%;
}

.auth-form__heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
}

.auth-form__hint {
  margin-top: 4px;
  margin-bottom: 8px;
  font-size: 0.925rem;
  opacity: 0.7;
}

.auth-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
